(() => {
  'use strict';

  const root = window.Shopify?.routes?.root || '/';
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' }).format(cents / 100);
  const decimalMoney = amount => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' }).format(Number(amount));
  const resizedImage = (url, width) => url ? `${url}${url.includes('?') ? '&' : '?'}width=${width}` : '';
  const overlay = qs('[data-overlay]');

  function showToast(message, error = false) {
    const toast = qs('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.style.background = error ? '#8D1F2D' : '#163A2A';
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  }

  function setOverlay(visible) {
    if (!overlay) return;
    overlay.hidden = !visible;
    requestAnimationFrame(() => overlay.classList.toggle('is-visible', visible));
    document.body.classList.toggle('is-locked', visible);
  }

  function closePanels() {
    qsa('[data-mobile-menu], [data-cart-drawer], [data-facets]').forEach(panel => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (panel.matches('[data-mobile-menu], [data-cart-drawer]')) panel.inert = true;
    });
    qsa('[data-menu-open], [data-cart-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    setOverlay(false);
  }

  function openPanel(panel, button) {
    closePanels();
    panel?.classList.add('is-open');
    panel?.setAttribute('aria-hidden', 'false');
    if (panel) panel.inert = false;
    button?.setAttribute('aria-expanded', 'true');
    setOverlay(true);
    qs('button, a, input', panel)?.focus();
  }

  qsa('[data-menu-open]').forEach(button => button.addEventListener('click', () => openPanel(qs('[data-mobile-menu]'), button)));
  qsa('[data-menu-close], [data-cart-close], [data-filter-close]').forEach(button => button.addEventListener('click', closePanels));
  overlay?.addEventListener('click', closePanels);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closePanels(); });

  qsa('[data-search-toggle]').forEach(button => button.addEventListener('click', () => {
    const form = qs('.header-search');
    form?.classList.toggle('is-open');
    if (form?.classList.contains('is-open')) qs('input[type="search"]', form)?.focus();
  }));

  const announcements = qsa('[data-announcement-bar] .announcement-bar__item');
  if (announcements.length > 1 && qs('[data-announcement-bar]')?.dataset.rotate === 'true') {
    let activeAnnouncement = 0;
    window.setInterval(() => {
      announcements[activeAnnouncement].classList.remove('is-active');
      activeAnnouncement = (activeAnnouncement + 1) % announcements.length;
      announcements[activeAnnouncement].classList.add('is-active');
    }, 4500);
  }

  let searchTimer;
  qsa('[data-predictive-search-input]').forEach(input => input.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const query = input.value.trim();
    const container = qs('[data-predictive-search]', input.form);
    if (query.length < 2) { container.hidden = true; container.innerHTML = ''; return; }
    searchTimer = window.setTimeout(async () => {
      try {
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        container.innerHTML = products.length ? products.map(product => `<a class="predictive-search__item" href="${escapeHTML(product.url)}"><img src="${escapeHTML(resizedImage(product.image, 104))}" width="52" height="52" alt=""><span><strong>${escapeHTML(product.title)}</strong><small>${decimalMoney(product.price)}</small></span></a>`).join('') : '<p>Nenhum produto encontrado.</p>';
        container.hidden = false;
      } catch { container.hidden = true; }
    }, 250);
  }));

  document.addEventListener('click', event => {
    if (!event.target.closest('[data-predictive-search-form]')) qsa('[data-predictive-search]').forEach(element => { element.hidden = true; });
  });

  async function getCart() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Não foi possível carregar o carrinho.');
    return response.json();
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(element => { element.textContent = count; element.hidden = count === 0; });
    qsa('[data-cart-drawer-count]').forEach(element => { element.textContent = `(${count})`; });
    qsa('[data-cart-open]').forEach(button => button.setAttribute('aria-label', `Carrinho: ${count} ${count === 1 ? 'item' : 'itens'}`));
  }

  function renderCart(cart) {
    const body = qs('[data-cart-drawer-body]');
    const footer = qs('[data-cart-drawer-footer]');
    if (!body) return;
    updateCartCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-state cart-drawer__empty"><span class="empty-state__icon">✦</span><h3>Seu carrinho espera um pouco de magia.</h3><p>Escolha peças especiais para começar sua decoração.</p><a class="button" href="/collections/all">Continuar comprando</a></div>';
      if (footer) footer.hidden = true;
      return;
    }
    body.innerHTML = `<div class="cart-lines">${cart.items.map((item, index) => `<div class="cart-line" data-cart-line="${escapeHTML(item.key)}"><a class="cart-line__image" href="${escapeHTML(item.url)}"><img src="${escapeHTML(resizedImage(item.image, 240))}" width="110" height="128" alt="${escapeHTML(item.product_title)}"></a><div class="cart-line__content"><a class="cart-line__title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>${item.variant_title ? `<p class="cart-line__variant">${escapeHTML(item.variant_title)}</p>` : ''}<strong class="cart-line__price">${money(item.final_line_price)}</strong><div class="cart-line__actions"><div class="cart-line__quantity"><button type="button" data-cart-quantity-minus data-key="${escapeHTML(item.key)}" aria-label="Diminuir quantidade">−</button><label class="visually-hidden" for="Drawer-${index}">Quantidade</label><input id="Drawer-${index}" class="quantity-input" type="number" min="0" value="${item.quantity}" data-cart-quantity data-key="${escapeHTML(item.key)}"><button type="button" data-cart-quantity-plus data-key="${escapeHTML(item.key)}" aria-label="Aumentar quantidade">+</button></div><button class="cart-line__remove" type="button" data-cart-remove data-key="${escapeHTML(item.key)}">Remover</button></div></div></div>`).join('')}</div>`;
    if (footer) footer.hidden = false;
    const total = qs('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  }

  async function changeCartLine(id, quantity) {
    const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: Math.max(0, Number(quantity)) }) });
    if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');
    renderCart(await response.json());
  }

  qsa('[data-cart-open]').forEach(button => button.addEventListener('click', async () => {
    try { await refreshCart(); } catch (error) { showToast(error.message, true); }
    openPanel(qs('[data-cart-drawer]'), button);
  }));

  async function addToCart(id, quantity = 1) {
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Não foi possível adicionar o produto.');
    await refreshCart();
    openPanel(qs('[data-cart-drawer]'), qs('[data-cart-open]'));
    showToast('Produto adicionado ao carrinho');
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-quick-add]');
    if (!button) return;
    button.disabled = true;
    try { await addToCart(button.dataset.variantId); } catch (error) { showToast(error.message, true); }
    finally { button.disabled = false; }
  });

  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    try { await changeCartLine(input.dataset.key, input.value); }
    catch (error) { showToast(error.message, true); }
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-quantity-minus], [data-cart-quantity-plus], [data-cart-remove]');
    if (!button) return;
    const line = button.closest('[data-cart-line]');
    const input = qs('[data-cart-quantity]', line);
    const quantity = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, Number(input?.value || 0) + (button.hasAttribute('data-cart-quantity-plus') ? 1 : -1));
    button.disabled = true;
    try { await changeCartLine(button.dataset.key, quantity); }
    catch (error) { showToast(error.message, true); button.disabled = false; }
  });

  qsa('[data-product-form]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = qs('[data-add-to-cart]', form);
    const formData = new FormData(form);
    button.disabled = true;
    try { await addToCart(formData.get('id'), formData.get('quantity') || 1); }
    catch (error) { showToast(error.message, true); }
    finally { button.disabled = false; }
  }));

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      connectedCallback() {
        const input = qs('input', this);
        qs('[data-quantity-minus]', this)?.addEventListener('click', () => { input.value = Math.max(Number(input.min || 1), Number(input.value) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
        qs('[data-quantity-plus]', this)?.addEventListener('click', () => { input.value = Number(input.value) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
      }
    });
  }

  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(qs('[data-variants-json]', this)?.textContent || '[]');
        this.addEventListener('change', event => this.onChange(event));
        this.onChange();
      }
      onChange(event) {
        let values = qsa('input[type="radio"]:checked', this).map(input => input.value);
        let variant = this.variants.find(item => item.options.every((option, index) => option === values[index]));
        const changedInput = event?.target?.matches('input[type="radio"]') ? event.target : null;
        if (!variant && changedInput) {
          const changedPosition = Number(changedInput.dataset.optionPosition) - 1;
          variant = this.variants.find(item => {
            const previousOptionsMatch = item.options.slice(0, changedPosition).every((option, index) => option === values[index]);
            return previousOptionsMatch && item.options[changedPosition] === changedInput.value;
          }) || this.variants.find(item => item.options[changedPosition] === changedInput.value);
          if (variant) {
            variant.options.forEach((value, index) => {
              const option = qsa(`input[type="radio"][data-option-position="${index + 1}"]`, this).find(item => item.value === value);
              if (option) option.checked = true;
            });
            values = variant.options;
          }
        }
        const section = this.closest('[data-product-section]');
        const input = qs('[data-variant-input]', section);
        const button = qs('[data-add-to-cart]', section);
        const text = qs('[data-add-to-cart-text]', section);
        if (!variant) { button.disabled = true; text.textContent = 'Indisponível'; return; }
        qsa('.product-option', this).forEach(fieldset => {
          const checked = qs('input[type="radio"]:checked', fieldset);
          const selected = qs('[data-selected-option]', fieldset);
          if (checked && selected) selected.textContent = checked.value;
        });
        qsa('.product-option', this).forEach((fieldset, fieldsetIndex) => {
          qsa('input[type="radio"]', fieldset).forEach(optionInput => {
            optionInput.disabled = fieldsetIndex > 0 && !this.variants.some(item => {
              const previousOptionsMatch = item.options.slice(0, fieldsetIndex).every((option, index) => option === values[index]);
              return item.available && previousOptionsMatch && item.options[fieldsetIndex] === optionInput.value;
            });
          });
        });
        input.value = variant.id;
        const pendingTreePrice = section.classList.contains('section--tree-product') && Number(variant.price) === 0;
        button.disabled = !variant.available || pendingTreePrice;
        text.textContent = pendingTreePrice ? 'Preço em atualização' : (variant.available ? 'Adicionar ao carrinho' : 'Esgotado');
        const price = qs('[data-product-price]', section);
        if (price) price.innerHTML = pendingTreePrice ? '<div class="price"><span class="price__current">Preço em atualização</span></div>' : `<div class="price${variant.compare_at_price > variant.price ? ' price--sale' : ''}"><span class="price__current">${money(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s class="price__compare">${money(variant.compare_at_price)}</s>` : ''}</div>`;
        const paymentCopy = qs('[data-product-payment-copy]', section);
        if (paymentCopy) paymentCopy.hidden = pendingTreePrice;
        const pixPrice = qs('[data-product-pix-price]', section);
        const pixSavings = qs('[data-product-pix-savings]', section);
        const pixDiscountPercent = Number(section.dataset.pixDiscountPercent ?? 5);
        const pixDiscountPrice = Math.round(Number(variant.price) * (1 - pixDiscountPercent / 100));
        if (pixPrice) pixPrice.textContent = money(pixDiscountPrice);
        if (pixSavings) pixSavings.textContent = money(Number(variant.price) - pixDiscountPrice);
        const installmentAmount = qs('[data-product-installment-amount]', section);
        if (installmentAmount) installmentAmount.textContent = money(Math.round(Number(variant.price) / 3));
        const mobilePrice = qs('[data-tree-mobile-price]');
        const mobileButton = qs('[data-tree-mobile-submit]');
        if (mobilePrice) mobilePrice.textContent = pendingTreePrice ? 'Preço em atualização' : money(variant.price);
        if (mobileButton) {
          mobileButton.disabled = !variant.available || pendingTreePrice;
          mobileButton.textContent = pendingTreePrice ? 'Preço em atualização' : (variant.available ? 'Adicionar ao carrinho' : 'Esgotado');
        }
        qsa('[data-tree-size-jump]').forEach(sizeButton => {
          const active = sizeButton.dataset.treeSizeJump === variant.options[0];
          sizeButton.classList.toggle('is-active', active);
          sizeButton.setAttribute('aria-pressed', String(active));
          const action = qs('[data-tree-size-action]', sizeButton);
          if (action) action.textContent = active ? 'Selecionado' : 'Escolher tamanho';
        });
        if (variant.featured_media) qs(`[data-media-target="${variant.featured_media.id}"]`, section)?.click();
        const variantUrl = new URL(this.dataset.url, window.location.origin);
        variantUrl.search = window.location.search;
        variantUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', `${variantUrl.pathname}${variantUrl.search}${window.location.hash}`);
        this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
      }
    });
  }

  if (!customElements.get('shipping-calculator')) {
    customElements.define('shipping-calculator', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('[data-product-section]');
        this.form = qs('[data-shipping-calculator-form]', this);
        this.input = qs('[data-shipping-zip]', this);
        this.button = qs('[data-shipping-submit]', this);
        this.result = qs('[data-shipping-result]', this);
        if (!this.form || !this.input || !this.button || !this.result) return;
        this.input.addEventListener('input', () => this.maskZip());
        this.form.addEventListener('submit', event => this.calculate(event));
        this.section?.addEventListener('variant:change', () => this.resetResult());
      }

      maskZip() {
        const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
        this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
        this.input.removeAttribute('aria-invalid');
      }

      resetResult() {
        this.result.hidden = true;
        this.result.innerHTML = '';
      }

      setLoading(loading) {
        this.button.disabled = loading;
        this.input.disabled = loading;
        qs('span', this.button).textContent = loading ? 'Consultando…' : 'Calcular frete';
        this.classList.toggle('is-loading', loading);
      }

      showMessage(message, type = 'info') {
        this.result.hidden = false;
        this.result.dataset.state = type;
        this.result.innerHTML = `<p>${escapeHTML(message)}</p>`;
      }

      itemFingerprint(item) {
        const properties = Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b));
        const sellingPlan = item.selling_plan_allocation?.selling_plan?.id || null;
        return JSON.stringify([Number(item.variant_id || item.id), sellingPlan, properties]);
      }

      async getCart() {
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Não foi possível acessar o carrinho.');
        return response.json();
      }

      async restoreCart(snapshot) {
        const current = await this.getCart();
        const originals = new Map(snapshot.items.map(item => [this.itemFingerprint(item), item]));
        const matched = new Set();
        const updates = {};

        current.items.forEach(item => {
          const fingerprint = this.itemFingerprint(item);
          const original = originals.get(fingerprint);
          updates[item.key] = original ? original.quantity : 0;
          if (original) matched.add(fingerprint);
        });

        if (Object.keys(updates).length) {
          const response = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates })
          });
          if (!response.ok) throw new Error('Não foi possível restaurar o carrinho.');
        }

        const missing = snapshot.items.filter(item => !matched.has(this.itemFingerprint(item))).map(item => {
          const restored = { id: item.variant_id, quantity: item.quantity };
          if (item.properties && Object.keys(item.properties).length) restored.properties = item.properties;
          const sellingPlan = item.selling_plan_allocation?.selling_plan?.id;
          if (sellingPlan) restored.selling_plan = sellingPlan;
          return restored;
        });

        if (missing.length) {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: missing })
          });
          if (!response.ok) throw new Error('Não foi possível restaurar o carrinho.');
        }
      }

      deliveryCopy(rate) {
        if (Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2) {
          const date = value => new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(new Date(`${value}T12:00:00`));
          return `Previsão entre ${date(rate.delivery_range[0])} e ${date(rate.delivery_range[1])}`;
        }
        if (Array.isArray(rate.delivery_days) && rate.delivery_days.length) {
          const days = rate.delivery_days.map(Number).filter(Number.isFinite);
          if (days.length === 1 || days[0] === days[days.length - 1]) return `Previsão de ${days[0]} dia${days[0] === 1 ? '' : 's'}`;
          return `Previsão de ${Math.min(...days)} a ${Math.max(...days)} dias`;
        }
        if (rate.description) return rate.description;
        const rateName = String(rate.presentment_name || rate.name || '').toLocaleLowerCase('pt-BR');
        const configuredDays = rateName.includes('express') ? this.dataset.shippingExpressDays : this.dataset.shippingStandardDays;
        return configuredDays ? `Estimativa: ${configuredDays}` : 'Prazo confirmado no checkout';
      }

      provinceFromZip(zip) {
        const value = Number(zip);
        const ranges = [
          [1000000, 19999999, 'SP'], [20000000, 28999999, 'RJ'], [29000000, 29999999, 'ES'],
          [30000000, 39999999, 'MG'], [40000000, 48999999, 'BA'], [49000000, 49999999, 'SE'],
          [50000000, 56999999, 'PE'], [57000000, 57999999, 'AL'], [58000000, 58999999, 'PB'],
          [59000000, 59999999, 'RN'], [60000000, 63999999, 'CE'], [64000000, 64999999, 'PI'],
          [65000000, 65999999, 'MA'], [66000000, 68899999, 'PA'], [68900000, 68999999, 'AP'],
          [69000000, 69299999, 'AM'], [69300000, 69399999, 'RR'], [69400000, 69899999, 'AM'],
          [69900000, 69999999, 'AC'], [70000000, 72799999, 'DF'], [72800000, 72999999, 'GO'],
          [73000000, 73699999, 'DF'], [73700000, 76799999, 'GO'], [77000000, 77999999, 'TO'],
          [78000000, 78899999, 'MT'], [78900000, 78999999, 'RO'], [79000000, 79999999, 'MS'],
          [80000000, 87999999, 'PR'], [88000000, 89999999, 'SC'], [90000000, 99999999, 'RS']
        ];
        return ranges.find(([start, end]) => value >= start && value <= end)?.[2] || null;
      }

      renderRates(rates, zip) {
        if (!rates.length) {
          this.showMessage('Não encontramos uma modalidade de entrega para este CEP. Confira o número ou fale com nosso atendimento.', 'error');
          return;
        }
        const items = rates.map(rate => {
          const value = Number(rate.price) === 0 ? 'Grátis' : decimalMoney(rate.price);
          const name = rate.presentment_name || rate.name || 'Entrega';
          return `<li><span><strong>${escapeHTML(name)}</strong><small>${escapeHTML(this.deliveryCopy(rate))}</small></span><b>${escapeHTML(value)}</b></li>`;
        }).join('');
        this.result.hidden = false;
        this.result.dataset.state = 'success';
        this.result.innerHTML = `<div class="product-shipping-calculator__result-heading"><span>Opções para ${escapeHTML(zip)}</span><small>Valor final confirmado no checkout</small></div><ul>${items}</ul>`;
      }

      async fetchRates(zip) {
        const province = this.provinceFromZip(zip);
        if (!province) throw new Error('Não foi possível identificar o estado deste CEP. Confira os números informados.');
        const params = new URLSearchParams({
          'shipping_address[zip]': zip,
          'shipping_address[country]': 'Brazil',
          'shipping_address[province]': province
        });
        const prepare = await fetch(`${root}cart/prepare_shipping_rates.json`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
          body: params.toString()
        });
        if (!prepare.ok) throw new Error('Não foi possível calcular o frete para este CEP.');

        for (let attempt = 0; attempt < 8; attempt += 1) {
          if (attempt) await new Promise(resolve => window.setTimeout(resolve, 700));
          const response = await fetch(`${root}cart/async_shipping_rates.json?${params}`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Não foi possível consultar as opções de entrega.');
          const data = await response.json();
          if (data?.shipping_rates) return data.shipping_rates;
        }
        throw new Error('O cálculo está demorando mais que o esperado. Tente novamente em instantes.');
      }

      async calculate(event) {
        event.preventDefault();
        const zipDigits = this.input.value.replace(/\D/g, '');
        if (zipDigits.length !== 8) {
          this.input.setAttribute('aria-invalid', 'true');
          this.showMessage('Digite um CEP válido com 8 números.', 'error');
          this.input.focus();
          return;
        }

        const variantId = Number(qs('[data-variant-input]', this.section)?.value);
        const quantity = Math.max(1, Number(qs('[name="quantity"]', this.section)?.value || 1));
        if (!variantId) {
          this.showMessage('Selecione uma opção disponível do produto.', 'error');
          return;
        }

        this.setLoading(true);
        this.showMessage('Buscando as melhores opções de entrega…');
        let snapshot;
        try {
          snapshot = await this.getCart();
          const added = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
          });
          if (!added.ok) {
            const error = await added.json().catch(() => ({}));
            throw new Error(error.description || 'Esta opção não está disponível para cálculo.');
          }
          const rates = await this.fetchRates(zipDigits);
          await this.restoreCart(snapshot);
          snapshot = null;
          this.renderRates(rates, this.input.value);
        } catch (error) {
          if (snapshot) {
            try { await this.restoreCart(snapshot); }
            catch (restoreError) { console.error(restoreError); }
          }
          this.showMessage(error.message || 'Não foi possível calcular o frete agora. Tente novamente.', 'error');
        } finally {
          this.setLoading(false);
        }
      }
    });
  }

  if (!customElements.get('tree-specs')) {
    customElements.define('tree-specs', class extends HTMLElement {
      connectedCallback() {
        this.specs = JSON.parse(qs('[data-tree-specs-json]', this)?.textContent || '[]');
        this.section = this.closest('[data-product-section]');
        this.section?.addEventListener('variant:change', event => this.update(event.detail.variant.id));
        const initialVariant = qs('[data-variant-input]', this.section)?.value;
        if (initialVariant) this.update(initialVariant);
      }
      update(variantId) {
        const spec = this.specs.find(item => String(item.id) === String(variantId));
        if (!spec) return;
        const number = value => new Intl.NumberFormat('pt-BR').format(Number(value || 0));
        const values = {
          height: spec.height || '—',
          diameter: spec.diameter || 'Consulte nossa equipe',
          tips: spec.tips != null && spec.tips !== '' ? number(spec.tips) : 'Consulte nossa equipe',
          lights: Number(spec.lights) > 0 ? `${number(spec.lights)} luzes` : (spec.lightingLabel || 'Consulte nossa equipe'),
          weight: spec.weight || 'Consulte nossa equipe',
          boxes: spec.boxes ? `${number(spec.boxes)} ${Number(spec.boxes) === 1 ? 'volume' : 'volumes'}` : 'Consulte nossa equipe'
        };
        Object.entries(values).forEach(([key, value]) => {
          qsa(`[data-tree-spec="${key}"]`, this.section).forEach(element => { element.textContent = value; });
        });
        const sku = qs('[data-tree-sku]', this);
        if (sku) sku.textContent = spec.sku || '';
      }
    });
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = qsa('[role="tab"]', this);
        this.panels = qsa('[role="tabpanel"]', this);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab));
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let targetIndex = index;
            if (event.key === 'ArrowLeft') targetIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowRight') targetIndex = (index + 1) % this.tabs.length;
            if (event.key === 'Home') targetIndex = 0;
            if (event.key === 'End') targetIndex = this.tabs.length - 1;
            this.select(this.tabs[targetIndex], true);
          });
        });
      }

      select(activeTab, focus = false) {
        const activePanel = activeTab.dataset.productTab;
        this.tabs.forEach(tab => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.productPanel !== activePanel; });
        if (focus) activeTab.focus();
      }
    });
  }

  qsa('[data-media-target]').forEach(button => button.addEventListener('click', () => {
    const gallery = button.closest('[data-product-gallery]');
    qsa('[data-media-target]', gallery).forEach(element => element.classList.toggle('is-active', element === button));
    qsa('[data-media-id]', gallery).forEach(element => {
      const isTarget = element.dataset.mediaId === button.dataset.mediaTarget;
      if (isTarget) {
        const image = qs('img[loading="lazy"]', element);
        if (image) image.loading = 'eager';
      }
      element.classList.toggle('is-active', isTarget);
    });
  }));

  qsa('[data-product-gallery]').forEach(gallery => {
    let hydrated = false;
    const hydrateThumbnails = () => {
      if (hydrated) return;
      hydrated = true;
      qsa('[data-thumbnail-src]', gallery).forEach(image => {
        image.src = image.dataset.thumbnailSrc;
        image.removeAttribute('data-thumbnail-src');
      });
    };
    const activeImage = qs('.product-media.is-active img', gallery);
    if (!activeImage || activeImage.complete) window.setTimeout(hydrateThumbnails, 0);
    else activeImage.addEventListener('load', hydrateThumbnails, { once: true });
    window.setTimeout(hydrateThumbnails, 6000);
  });

  qsa('[data-gallery-prev], [data-gallery-next]').forEach(button => button.addEventListener('click', () => {
    const gallery = button.closest('[data-product-gallery]');
    const thumbs = qsa('[data-media-target]', gallery);
    if (!thumbs.length) return;
    const current = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
    const direction = button.hasAttribute('data-gallery-prev') ? -1 : 1;
    thumbs[(current + direction + thumbs.length) % thumbs.length].click();
  }));

  qsa('[data-hero-video]').forEach(video => {
    const hero = video.closest('.hero-christmas');
    const button = qs('[data-hero-video-toggle]', hero);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection?.saveData === true;
    let loadRequested = false;

    const updateVideoControl = () => {
      if (!button) return;
      const paused = video.paused;
      button.dataset.state = paused ? 'paused' : 'playing';
      button.setAttribute('aria-label', paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
    };

    const loadHeroVideo = ({ play = false } = {}) => {
      if (!loadRequested) {
        qsa('source[data-src]', video).forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.load();
        loadRequested = true;
      }
      if (play) video.play().catch(updateVideoControl);
    };

    video.addEventListener('canplay', () => hero?.classList.add('is-video-ready'), { once: true });
    video.addEventListener('play', updateVideoControl);
    video.addEventListener('pause', updateVideoControl);

    if (button) button.addEventListener('click', () => {
      if (!loadRequested || video.paused) loadHeroVideo({ play: true });
      else video.pause();
    });

    const canAutoplay = video.dataset.autoplay === 'true'
      && window.matchMedia('(min-width: 750px)').matches
      && !reduceMotion
      && !saveData;
    if (canAutoplay) {
      window.addEventListener('load', () => {
        const startVideo = () => loadHeroVideo({ play: true });
        if ('requestIdleCallback' in window) window.requestIdleCallback(startVideo, { timeout: 2500 });
        else window.setTimeout(startVideo, 1200);
      }, { once: true });
    }

    updateVideoControl();
  });

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.loadRecommendations();
        }, { rootMargin: '700px 0px' });
        this.observer.observe(this);
      }

      async loadRecommendations() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const html = document.createElement('div');
          html.innerHTML = await response.text();
          const recommendations = qs('product-recommendations', html);
          if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
        } catch { /* Recommendations are progressive enhancement. */ }
      }
    });
  }

  qsa('[data-filter-open]').forEach(button => button.addEventListener('click', () => openPanel(qs('[data-facets]'), button)));
  qsa('[data-sort-select]').forEach(select => select.addEventListener('change', () => select.form.submit()));

  qsa('[data-carousel-prev], [data-carousel-next]').forEach(button => button.addEventListener('click', () => {
    const carousel = qs('[data-product-carousel]', button.closest('.featured-collection'));
    if (!carousel) return;
    const direction = button.hasAttribute('data-carousel-prev') ? -1 : 1;
    carousel.scrollBy({ left: carousel.clientWidth * .82 * direction, behavior: 'smooth' });
  }));

  qsa('[data-tree-size-jump]').forEach(button => button.addEventListener('click', () => {
    const picker = qs('variant-selects');
    const option = qsa('input[type="radio"]', picker).find(input => input.value === button.dataset.treeSizeJump);
    if (!option) return;
    option.checked = true;
    option.dispatchEvent(new Event('change', { bubbles: true }));
    (qs('.tree-purchase-options') || qs('[data-product-section]'))?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }));

  qs('[data-tree-mobile-submit]')?.addEventListener('click', () => {
    const button = qs('.section--tree-product [data-add-to-cart]');
    if (button && !button.disabled) button.click();
  });

  qsa('[data-format-number]').forEach(element => {
    const value = Number(element.textContent.trim());
    if (Number.isFinite(value)) element.textContent = new Intl.NumberFormat('pt-BR').format(value);
  });

  const supportConcierge = qs('[data-support-concierge]');
  if (supportConcierge) {
    const supportPanel = qs('[data-support-panel]', supportConcierge);
    const supportLauncher = qs('[data-support-open]', supportConcierge);
    const supportStatus = qs('[data-support-status]', supportConcierge);
    const supportUnread = qs('[data-support-unread]', supportConcierge);
    const supportWhatsappLink = qs('[data-support-whatsapp-link]', supportConcierge);
    const jivoEnabled = supportConcierge.dataset.supportJivo === 'true';
    const whatsappEnabled = supportConcierge.dataset.supportWhatsapp === 'true';
    let lastSupportTopic = 'Atendimento geral';
    let supportUnreadCount = 0;
    let supportReturnFocus = null;

    const jivoIsReady = () => jivoEnabled && typeof window.jivo_api?.open === 'function';
    const updateSupportStatus = () => {
      if (!supportStatus) return;
      const isReady = jivoIsReady();
      supportStatus.classList.toggle('is-online', isReady);
      supportStatus.lastChild.textContent = isReady ? ' Chat online' : ' Atendimento pelo WhatsApp';
    };

    const currentProductContext = () => {
      const variantInput = qs('[data-variant-input]');
      const selectedOptions = qsa('[data-selected-option]').map(option => option.textContent.trim()).filter(Boolean);
      const productPrice = qs('[data-product-price]')?.textContent.replace(/\s+/g, ' ').trim();
      return {
        title: supportConcierge.dataset.productTitle || '',
        url: supportConcierge.dataset.productUrl || window.location.href,
        variant: selectedOptions.join(' · ') || supportConcierge.dataset.productVariant || '',
        variantId: variantInput?.value || '',
        sku: supportConcierge.dataset.productSku || '',
        price: productPrice || ''
      };
    };

    const buildWhatsappUrl = topic => {
      const phone = supportConcierge.dataset.supportPhone;
      if (!phone) return '';
      const productContext = currentProductContext();
      const details = [supportConcierge.dataset.supportMessage, `Assunto: ${topic}`];
      if (productContext.title) details.push(`Produto: ${productContext.title}`);
      if (productContext.variant) details.push(`Opção: ${productContext.variant}`);
      details.push(`Página: ${window.location.href}`);
      return `https://wa.me/${phone}?text=${encodeURIComponent(details.filter(Boolean).join('\n'))}`;
    };

    const sendJivoContext = topic => {
      if (!jivoIsReady()) return false;
      const productContext = currentProductContext();
      const context = [
        { title: 'Assunto escolhido', content: topic },
        { title: 'Página de origem', content: document.title, link: window.location.href }
      ];
      if (productContext.title) {
        context.push({ title: 'Produto', content: productContext.title, link: productContext.url });
        if (productContext.variant) context.push({ title: 'Configuração', content: productContext.variant });
        if (productContext.variantId) context.push({ title: 'ID da variante', content: productContext.variantId });
        if (productContext.sku) context.push({ title: 'SKU', content: productContext.sku });
        if (productContext.price) context.push({ title: 'Preço exibido', content: productContext.price });
      }
      try {
        window.jivo_api.setWidgetColor?.('#74172A', '#315744');
        window.jivo_api.sendPageTitle?.(document.title, true, window.location.href);
        window.jivo_api.setCustomData?.(context);
        return true;
      } catch { return false; }
    };

    const closeSupportPanel = ({ restoreFocus = true } = {}) => {
      supportConcierge.classList.remove('is-open');
      supportPanel?.setAttribute('aria-hidden', 'true');
      if (supportPanel) supportPanel.inert = true;
      supportLauncher?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('support-concierge-open');
      if (restoreFocus) supportReturnFocus?.focus();
    };

    const openSupportPanel = () => {
      supportReturnFocus = document.activeElement;
      supportConcierge.classList.add('is-open');
      supportPanel?.setAttribute('aria-hidden', 'false');
      if (supportPanel) supportPanel.inert = false;
      supportLauncher?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('support-concierge-open');
      supportUnreadCount = 0;
      if (supportUnread) { supportUnread.hidden = true; supportUnread.textContent = '0'; }
      window.dataLayer?.push({ event: 'support_concierge_open' });
      window.setTimeout(() => qs('[data-support-topic], [data-support-start]', supportPanel)?.focus(), 80);
    };

    const startSupport = topic => {
      lastSupportTopic = topic || lastSupportTopic;
      window.dataLayer?.push({ event: 'support_concierge_start', support_topic: lastSupportTopic, support_channel: jivoIsReady() ? 'jivo' : 'whatsapp' });
      if (sendJivoContext(lastSupportTopic)) {
        closeSupportPanel({ restoreFocus: false });
        try { window.jivo_api.open({ start: 'chat' }); } catch { window.jivo_api.open(); }
        return;
      }
      const whatsappUrl = buildWhatsappUrl(lastSupportTopic);
      if (whatsappEnabled && whatsappUrl) {
        const whatsappWindow = window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
        if (!whatsappWindow) window.location.href = whatsappUrl;
        closeSupportPanel({ restoreFocus: false });
        return;
      }
      showToast('Nosso atendimento está temporariamente indisponível. Tente novamente em instantes.', true);
    };

    supportLauncher?.addEventListener('click', openSupportPanel);
    qsa('[data-support-close]', supportConcierge).forEach(button => button.addEventListener('click', () => closeSupportPanel()));
    qsa('[data-support-topic]', supportConcierge).forEach(button => button.addEventListener('click', () => startSupport(button.dataset.supportTopic)));
    qs('[data-support-start]', supportConcierge)?.addEventListener('click', () => startSupport(lastSupportTopic));
    supportWhatsappLink?.addEventListener('click', () => {
      supportWhatsappLink.href = buildWhatsappUrl(lastSupportTopic);
      window.dataLayer?.push({ event: 'support_concierge_start', support_topic: lastSupportTopic, support_channel: 'whatsapp' });
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && supportConcierge.classList.contains('is-open')) closeSupportPanel();
    });

    const previousJivoLoad = window.jivo_onLoadCallback;
    window.jivo_onLoadCallback = function (...args) {
      if (typeof previousJivoLoad === 'function') previousJivoLoad.apply(this, args);
      try {
        window.jivo_api.setRules?.([]);
        window.jivo_api.close?.();
      } catch {}
      updateSupportStatus();
      sendJivoContext('Navegação no site');
    };

    const previousJivoOpen = window.jivo_onOpen;
    window.jivo_onOpen = function (...args) {
      if (typeof previousJivoOpen === 'function') previousJivoOpen.apply(this, args);
      closeSupportPanel({ restoreFocus: false });
    };

    const previousJivoMessage = window.jivo_onMessageReceived;
    window.jivo_onMessageReceived = function (...args) {
      if (typeof previousJivoMessage === 'function') previousJivoMessage.apply(this, args);
      if (supportConcierge.classList.contains('is-open')) return;
      supportUnreadCount += 1;
      if (supportUnread) {
        supportUnread.textContent = String(Math.min(supportUnreadCount, 9));
        supportUnread.hidden = false;
      }
    };

    if (supportWhatsappLink) supportWhatsappLink.href = buildWhatsappUrl(lastSupportTopic);
    updateSupportStatus();
    let supportReadinessChecks = 0;
    const supportReadinessTimer = window.setInterval(() => {
      supportReadinessChecks += 1;
      updateSupportStatus();
      if (jivoIsReady() || supportReadinessChecks >= 20) window.clearInterval(supportReadinessTimer);
    }, 500);
  }

  qsa('[data-countdown]').forEach(countdown => {
    const updateCountdown = () => {
      const now = new Date();
      let target = new Date(now.getFullYear(), Number(countdown.dataset.targetMonth) - 1, Number(countdown.dataset.targetDay), 23, 59, 59);
      if (now > target) target = new Date(now.getFullYear() + 1, Number(countdown.dataset.targetMonth) - 1, Number(countdown.dataset.targetDay), 23, 59, 59);
      const remaining = Math.max(0, target - now);
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      const setValue = (selector, value) => { const element = qs(selector, countdown); if (element) element.textContent = String(value).padStart(2, '0'); };
      setValue('[data-countdown-days]', days);
      setValue('[data-countdown-hours]', hours);
      setValue('[data-countdown-minutes]', minutes);
      setValue('[data-countdown-seconds]', seconds);
    };
    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });

  qsa('[data-tree-guide-calculator]').forEach(calculator => {
    const form = qs('form', calculator);
    const result = qs('[data-tree-guide-result]', calculator);
    if (!form || !result) return;
    const sizes = {
      compact: { label: 'Uma árvore de 1,50 a 1,80 m', query: 'arvore 1,80' },
      standard: { label: 'Uma árvore de 1,80 a 2,10 m', query: 'arvore 2,10' },
      high: { label: 'Uma árvore de 2,10 a 2,40 m', query: 'arvore 2,40' },
      grand: { label: 'Uma árvore de 2,40 a 3,00 m', query: 'arvore 3,00' }
    };
    const profiles = {
      slim: 'O formato slim preserva a circulação e ocupa até 90 cm de largura.',
      classic: 'O formato clássico equilibra presença, volume e espaço para decorar.',
      full: 'O formato amplo cria máximo impacto em ambientes com bastante área livre.'
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      const size = sizes[form.elements.ceiling.value];
      const profile = profiles[form.elements.floor.value];
      if (!size || !profile) return;
      qs('[data-tree-guide-size]', result).textContent = size.label;
      qs('[data-tree-guide-shape]', result).textContent = profile;
      const link = qs('[data-tree-guide-link]', result);
      if (link) link.href = `${root}search?q=${encodeURIComponent(size.query)}&type=product`;
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });
})();
